<form [formGroup]="formFilter" cForm class="container-filter">
    <mat-form-field>
        <mat-label>Busqueda</mat-label>
        <input
          (keyup)="filtroGeneral($event)"
          matInput
          formControlName="generalFilter"
          placeholder="Busqueda por RUT o Nombre "
        />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Estado Conexión</mat-label>
        <mat-select>
          <mat-option value="contectado">Contectado</mat-option>
          <mat-option value="noConectado">No Contectado</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Elige el rango de dias</mat-label>
        <mat-date-range-input
          [formGroup]="formFilter"
          [rangePicker]="picker"
          format="dd/MM/YYYY"
        >
          <input
            (keyup.enter)="filtrarPorFecha()"
            matStartDate
            formControlName="start"
            placeholder="Dia de Inicio"
          />
          <input
            (keyup.enter)="filtrarPorFecha()"
            matEndDate
            formControlName="end"
            placeholder="Dia de Termino"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
</form>
